import React from 'react';
import {
    PAYMENT_STANDING_ORDER,
    PAYMENT_STANDING_ORDER_FORM,
    PAYMENT_STANDING_ORDER_PAYEE,
} from 'constants/shared/routes';
import PageContainer from 'components/shared/generic/pageContainer/presentational/PageContainer';
import SectionTitle from 'components/shared/generic/sectionTitle/presentational/SectionTitle';
import PayeeInfiniteScrollContainer from 'components/shared/layout/payeeInfiniteScroll/containers/PayeeInfiniteScrollContainer';
import DataCheck from 'components/shared/generic/dataCheck/presentational/DataCheck';
import { useGetPayeesQuery } from 'lib/services/payee';

const StandingOrderPayeeContainer = () => {
    const { data: payees, isFetching, error } = useGetPayeesQuery();

    return (
        <PageContainer>
            <SectionTitle
                title="Standing Order Payee"
                backRoute={PAYMENT_STANDING_ORDER}
            />
            <DataCheck
                data={payees}
                isLoading={isFetching}
                error={error}
                noDataMessage="You currently have no payees"
            >
                <PayeeInfiniteScrollContainer
                    backRoute={PAYMENT_STANDING_ORDER_PAYEE}
                    nextRoute={PAYMENT_STANDING_ORDER_FORM}
                    flow="standing order"
                />
            </DataCheck>
        </PageContainer>
    );
};

export default StandingOrderPayeeContainer;
